/**
 * Bulgarian Translations — Impact Core i18n
 *
 * Flat key-value structure. Keys use dot notation for namespacing.
 * Coverage: navigation, actions, statuses, dashboard labels, form labels.
 */

export const bg: Record<string, string> = {
  // Navigation
  'nav.dashboard': 'Табло',
  'nav.funds': 'Фондове',
  'nav.investments': 'Инвестиции',
  'nav.investees': 'Получатели на инвестиции',
  'nav.esg': 'ESG Преглед',
  'nav.compliance': 'Съответствие',
  'nav.reports': 'Доклади',
  'nav.settings': 'Настройки',
  'nav.users': 'Потребители',
  'nav.sfdr': 'SFDR',
  'nav.pai': 'PAI Индикатори',
  'nav.taxonomy': 'Таксономия на ЕС',
  'nav.filings': 'Подадени документи',
  'nav.calendar': 'Календар',
  'nav.submit': 'Подаване на данни',
  'nav.submissions': 'Моите подавания',
  'nav.benchmarks': 'Референтни показатели',
  'nav.messages': 'Съобщения',
  'nav.portfolio': 'Портфолио',
  'nav.performance': 'Резултати на фондове',
  'nav.esgSummary': 'ESG Обобщение',
  'nav.pipeline': 'Конвейер',
  'nav.dueDiligence': 'Надлежна проверка',
  'nav.impact': 'Показатели за въздействие',
  'nav.sdg': 'Картиране на ЦУР',
  'nav.audit': 'Одитна следа',
  'nav.snapshots': 'Моментни снимки',
  'nav.knowledgeGraph': 'Граф на знанието',
  'nav.geographic': 'Географски',
  'nav.bi': 'BI Студио',
  'nav.ai': 'AI Асистент',
  'nav.tasks': 'Задачи',
  'nav.csrd': 'CSRD',
  'nav.regulatory': 'Регулаторен монитор',

  // Common Actions
  'action.create': 'Създаване',
  'action.edit': 'Редактиране',
  'action.delete': 'Изтриване',
  'action.save': 'Запазване',
  'action.cancel': 'Отмяна',
  'action.submit': 'Подаване',
  'action.approve': 'Одобряване',
  'action.reject': 'Отхвърляне',
  'action.download': 'Изтегляне',
  'action.export': 'Експортиране',
  'action.import': 'Импортиране',
  'action.filter': 'Филтриране',
  'action.search': 'Търсене',
  'action.refresh': 'Обновяване',
  'action.close': 'Затваряне',
  'action.back': 'Назад',
  'action.next': 'Напред',
  'action.previous': 'Предишен',
  'action.viewAll': 'Преглед на всички',
  'action.viewDetails': 'Преглед на детайли',
  'action.generate': 'Генериране',
  'action.signOut': 'Изход',
  'action.addNew': 'Добавяне',
  'action.invite': 'Покана',

  // Statuses
  'status.draft': 'Чернова',
  'status.submitted': 'Подадено',
  'status.validated': 'Валидирано',
  'status.approved': 'Одобрено',
  'status.rejected': 'Отхвърлено',
  'status.pending': 'Изчакващо',
  'status.inProgress': 'В процес',
  'status.overdue': 'Просрочено',
  'status.compliant': 'Съответстващо',
  'status.filed': 'Подадено',
  'status.active': 'Активно',
  'status.inactive': 'Неактивно',
  'status.closed': 'Затворено',
  'status.fundraising': 'Набиране на средства',
  'status.investing': 'Инвестиране',
  'status.harvesting': 'Прибиране на реколтата',

  // Dashboard Labels
  'dashboard.portfolioOverview': 'Преглед на портфолиото',
  'dashboard.complianceStatus': 'Статус на съответствие',
  'dashboard.collectionProgress': 'Напредък на събирането',
  'dashboard.activityFeed': 'Активност',
  'dashboard.quickActions': 'Бързи действия',
  'dashboard.investmentPipeline': 'Инвестиционен конвейер',
  'dashboard.totalFunds': 'Общо фондове',
  'dashboard.aum': 'AUM',
  'dashboard.activeInvestments': 'Активни инвестиции',
  'dashboard.totalInvestees': 'Получатели на инвестиции',
  'dashboard.recentActivity': 'Скорошна активност',

  // LP Dashboard Labels
  'lp.totalCommitted': 'Общо ангажирано',
  'lp.capitalCalled': 'Изискан капитал',
  'lp.distributed': 'Разпределено',
  'lp.netPosition': 'Нетна позиция',
  'lp.tvpi': 'TVPI',
  'lp.dpi': 'DPI',
  'lp.fundPerformance': 'Резултати на фондове',
  'lp.esgSummary': 'ESG Обобщение',
  'lp.reportLibrary': 'Библиотека с доклади',
  'lp.taxonomyAligned': 'Съответствие с таксономията',
  'lp.paiCoverage': 'PAI Покритие',
  'lp.portfolioPerformance': 'Резултати на LP портфолиото',

  // Fund Labels
  'fund.name': 'Име на фонда',
  'fund.code': 'Код на фонда',
  'fund.vintage': 'Година на създаване',
  'fund.size': 'Размер на фонда',
  'fund.targetSize': 'Целеви размер',
  'fund.currency': 'Валута',
  'fund.strategy': 'Стратегия',
  'fund.status': 'Статус',
  'fund.sfdrCategory': 'SFDR Категория',
  'fund.geographyFocus': 'Географски фокус',
  'fund.sectorFocus': 'Секторен фокус',

  // Form Labels
  'form.name': 'Име',
  'form.email': 'Имейл',
  'form.country': 'Държава',
  'form.amount': 'Сума',
  'form.currency': 'Валута',
  'form.date': 'Дата',
  'form.description': 'Описание',
  'form.notes': 'Бележки',
  'form.type': 'Тип',
  'form.period': 'Период',
  'form.year': 'Година',
  'form.required': 'Задължително',
  'form.optional': 'По избор',

  // Table Headers
  'table.fund': 'Фонд',
  'table.commitment': 'Ангажимент',
  'table.called': 'Изискано',
  'table.distributed': 'Разпределено',
  'table.tvpi': 'TVPI',
  'table.status': 'Статус',
  'table.regulation': 'Регулация',
  'table.filingType': 'Тип документ',
  'table.reportingPeriod': 'Период',
  'table.createdAt': 'Създаден',
  'table.actions': 'Действия',

  // Compliance
  'compliance.sfdr': 'SFDR',
  'compliance.taxonomy': 'Таксономия на ЕС',
  'compliance.pai': 'PAI',
  'compliance.dataCompleteness': 'Пълнота на данните',
  'compliance.nextDeadline': 'Следващ краен срок',

  // Reports
  'report.quarterly': 'Тримесечен доклад',
  'report.annual': 'Годишен доклад',
  'report.paiStatement': 'PAI Декларация',
  'report.taxonomyReport': 'Доклад по таксономия',
  'report.generatedAt': 'Генерирано',
  'report.version': 'Версия',

  // General
  'general.loading': 'Зареждане...',
  'general.noData': 'Няма налични данни',
  'general.error': 'Възникна грешка',
  'general.retry': 'Опитайте отново',
  'general.total': 'Общо',
  'general.page': 'Страница',
  'general.of': 'от',
  'general.showing': 'Показване на',
  'general.results': 'резултати',
  'general.language': 'Език',
  'general.english': 'Английски',
  'general.french': 'Френски',
};
